import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 12h2","key":"svg-0"}],["path",{"d":"M17 12h2","key":"svg-1"}],["path",{"d":"M11 12h2","key":"svg-2"}]]

const IconLineDashed = createReactComponent('outline', 'line-dashed', 'LineDashed', __iconNode);

export default IconLineDashed;